import Vue from 'vue'
import * as plugins from './bootstrap-vue-plugins'

Object.values(plugins).forEach(comp => Vue.use(comp))
